import {
  Component,
  OnInit,
  signal,
  OnDestroy,
  inject,
  HostListener,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormChecker } from 'src/app/shared/helpers/check-form';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, OnDestroy {
  public _auth = inject(AuthService);

  public loginForm: FormGroup;

  public passwordShown = signal(false);

  // Used for responsive layout adjustments
  public desktopMode: boolean = true;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.formInitialization();
    this.checkScreenSize();
  }

  ngOnDestroy(): void {
    this._auth.loginSubscription && this._auth.loginSubscription.unsubscribe();
    // AuthService is a root singleton; if we tear down mid-login the loading
    // flag would otherwise stay true and pin the full-screen spinner.
    this._auth.loading = false;
  }

  private formInitialization() {
    // Arriving from e-mail verification (audit F-04): prefill the address the user just
    // verified so the only thing left to type is the password.
    const prefillEmail = (history.state as { email?: string })?.email || null;
    this.loginForm = this.fb.group({
      identification: [prefillEmail, [Validators.required, Validators.email]],
      password: [null, Validators.required],
    });
  }

  public login() {
    FormChecker.checkForm(this.loginForm);

    if (this.loginForm.invalid) return;

    this._auth.login(this.loginForm);
  }

  /**
   * Checks screen size and sets desktopMode accordingly
   * Used for responsive layout adjustments
   */
  @HostListener('window:resize')
  private checkScreenSize() {
    this.desktopMode = window.innerWidth >= 993;
  }
}
